import { actions } from './actions'

const menuActiveState = (state = { isOpen: false, selectedMenu: 'companies' }, action) => {
  switch (action.type) {
    case actions.set:
      return Object.assign({}, state.menuState, { isOpen: action.menuState.isOpen })
    default:
      return state
  }
}

export default menuActiveState



// WEBPACK FOOTER //
// ./src/store/menu-state/reducer.js